import fields from './fields';
import validations from './validations';

export default {
  ...fields,
  ...validations,
  invoice_flow__multi_time_remainin: 'Pozostały czas',
  invoice_flow__multi_or: 'LUB',
  invoice_flow__multi_copy_code: 'Kopiuj kod',
  invoice_flow__multi_open_app: 'Otwórz w aplikacji',
  invoice_flow__multi_return_button: 'Powrót do strony',
  invoice_flow__card_transfer_button: 'Potwierdź',

  //Steps
  invoice_flow__multi_rapipago_step_1:
    'Aby zapłacić online, skopiuj wygenerowany kod z formularza płatności i dokonaj płatności w aplikacji płatniczej.',
  invoice_flow__multi_rapipago_step_2:
    'Aby zapłacić offline, zapisz wygenerowany kod kreskowy (voucher) lub wydrukuj go i udaj się do placówki Rapipago lub sklepu partnerskiego, aby dokonać płatności.',
  invoice_flow__multi_upi_qr_step_1: 'Zeskanuj lub skopiuj kod QR powyżej',
  invoice_flow__multi_upi_qr_step_2: 'Dokonaj płatności',
  invoice_flow__multi_step_3:
    'Potwierdź płatność, podając <b>{attributes}</b> i naciśnij przycisk „Potwierdź”',
  invoice_flow__multi_upi_qr_mob_step_1:
    'Zeskanuj kod QR powyżej lub użyj przycisku „Otwórz w aplikacji”',

  invoice_flow__multi_bank_transfer_step_1: 'Skopiuj dane do przelewu',
  invoice_flow__multi_bank_transfer_step_2: 'Dokonaj płatności',

  invoice_flow__card_transfer_step_1: 'Kopiuj dane do przelewu',
  invoice_flow__card_transfer_step_2:
    'Przelej wskazaną kwotę (skorzystaj ze swojego konta bankowego lub odwiedź najbliższy bank albo terminal samoobsługowy)',
  invoice_flow__card_transfer_step_3: 'Wypełnij dane potwierdzenia: <b>{attributes}</b>',
  invoice_flow__card_transfer_step_4:
    'Po pomyślnym wykonaniu przelewu — kliknij <b>„Potwierdź”</b>',
};
